export default "__VITE_ASSET__5dd5452a__"